import { render, staticRenderFns } from "./ActionsListPanel.vue?vue&type=template&id=4754a984&scoped=true&"
import script from "./ActionsListPanel.vue?vue&type=script&lang=ts&"
export * from "./ActionsListPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ActionsListPanel.vue?vue&type=style&index=0&id=4754a984&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754a984",
  null
  
)

export default component.exports